import React from 'react';

/**
 * Croix de fermeture réutilisable, en haut à droite d'une modale.
 * Reste visible même quand la modale défile (sticky) — utile sur mobile web
 * où le bouton « Fermer » du bas peut être hors écran.
 * À placer comme PREMIER enfant du conteneur de la modale.
 */
export default function ModalClose({ onClick }) {
  return (
    <div className="modal-x-wrap">
      <button type="button" className="modal-x" onClick={onClick} aria-label="Fermer">
        ✕
      </button>
    </div>
  );
}
